var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.326,
    height: 18,
    viewBox: "0 0 16.326 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar",
    transform: "translate(-2.25 -1.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49074",
    "data-name": "Path 49074",
    d: "M7.878,5.017A.632.632,0,0,1,7.25,4.39V1.878a.628.628,0,1,1,1.256,0V4.39A.632.632,0,0,1,7.878,5.017Z",
    transform: "translate(-0.814)",
    fill: "#9c9baa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49075",
    "data-name": "Path 49075",
    d: "M15.878,5.017a.632.632,0,0,1-.628-.628V1.878a.628.628,0,1,1,1.256,0V4.39A.632.632,0,0,1,15.878,5.017Z",
    transform: "translate(-2.116)",
    fill: "#9c9baa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49076",
    "data-name": "Path 49076",
    d: "M8.337,14.175a.833.833,0,0,1-.318-.067.8.8,0,0,1-.519-.77.833.833,0,0,1,.067-.318.967.967,0,0,1,.176-.276.864.864,0,0,1,.276-.176.855.855,0,0,1,.913.176.88.88,0,0,1,.243.594,1.258,1.258,0,0,1-.017.167.532.532,0,0,1-.05.151.634.634,0,0,1-.075.151,1.319,1.319,0,0,1-.1.126.88.88,0,0,1-.594.243Z",
    transform: "translate(-0.855 -1.832)",
    fill: "#9c9baa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49077",
    "data-name": "Path 49077",
    d: "M11.837,14.174a.833.833,0,0,1-.318-.067.8.8,0,0,1-.519-.77.833.833,0,0,1,.067-.318.967.967,0,0,1,.176-.276.864.864,0,0,1,.276-.176.839.839,0,0,1,.913.176.88.88,0,0,1,.243.594,1.258,1.258,0,0,1-.017.167.532.532,0,0,1-.05.151.634.634,0,0,1-.075.151,1.319,1.319,0,0,1-.1.126.88.88,0,0,1-.594.243Z",
    transform: "translate(-1.424 -1.832)",
    fill: "#9c9baa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49078",
    "data-name": "Path 49078",
    d: "M15.337,14.174a.833.833,0,0,1-.318-.067.864.864,0,0,1-.276-.176l-.1-.126a.634.634,0,0,1-.075-.151.532.532,0,0,1-.05-.151,1.258,1.258,0,0,1-.017-.167.88.88,0,0,1,.243-.594.864.864,0,0,1,.276-.176.836.836,0,0,1,.913.176.88.88,0,0,1,.243.594,1.258,1.258,0,0,1-.017.167.532.532,0,0,1-.05.151.634.634,0,0,1-.075.151,1.319,1.319,0,0,1-.1.126.88.88,0,0,1-.594.243Z",
    transform: "translate(-1.994 -1.832)",
    fill: "#9c9baa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49079",
    "data-name": "Path 49079",
    d: "M8.337,17.676a.833.833,0,0,1-.318-.067.967.967,0,0,1-.276-.176.88.88,0,0,1-.243-.594.833.833,0,0,1,.067-.318.781.781,0,0,1,.176-.276.841.841,0,1,1,.594,1.432Z",
    transform: "translate(-0.855 -2.403)",
    fill: "#9c9baa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49080",
    "data-name": "Path 49080",
    d: "M11.837,17.676A.829.829,0,0,1,11,16.839a.833.833,0,0,1,.067-.318.781.781,0,0,1,.176-.276.877.877,0,0,1,1.189,0,.781.781,0,0,1,.176.276.833.833,0,0,1,.067.318.829.829,0,0,1-.837.837Z",
    transform: "translate(-1.424 -2.403)",
    fill: "#9c9baa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49081",
    "data-name": "Path 49081",
    d: "M15.337,17.674a.88.88,0,0,1-.594-.243.781.781,0,0,1-.176-.276.789.789,0,0,1,0-.636.781.781,0,0,1,.176-.276.836.836,0,0,1,.753-.226.505.505,0,0,1,.159.05.634.634,0,0,1,.151.075,1.319,1.319,0,0,1,.126.1.837.837,0,0,1-.594,1.432Z",
    transform: "translate(-1.994 -2.401)",
    fill: "#9c9baa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49082",
    "data-name": "Path 49082",
    d: "M17.61,9.6H3.378a.628.628,0,1,1,0-1.256H17.61a.628.628,0,0,1,0,1.256Z",
    transform: "translate(-0.081 -1.154)",
    fill: "#9c9baa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49083",
    "data-name": "Path 49083",
    d: "M13.762,19.494h-6.7c-3.056,0-4.814-1.758-4.814-4.814V7.564c0-3.056,1.758-4.814,4.814-4.814h6.7c3.056,0,4.814,1.758,4.814,4.814V14.68C18.576,17.736,16.817,19.494,13.762,19.494ZM7.064,4.006c-2.394,0-3.558,1.164-3.558,3.558V14.68c0,2.394,1.164,3.558,3.558,3.558h6.7c2.394,0,3.558-1.164,3.558-3.558V7.564c0-2.394-1.164-3.558-3.558-3.558Z",
    transform: "translate(0 -0.244)",
    fill: "#9c9baa"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.61b5a9c66f918aeab5daf4d4a882d649.svg";
export { ForwardRef as ReactComponent };